/* Hiemal32 clubs: shared data + location helpers for the Look up section and the club map page.
   Reads the live club list from /pages/clubs-data (a page using the "clubs-data" template). */
(function () {
  if (window.H32Clubs) return;

  var FEED = (window.H32_CLUBS_FEED || '/pages/clubs-data');
  var LOC_KEY = 'h32-location';
  var cache = null;

  function today() { var d = new Date(); return d.toISOString().slice(0, 10); }

  function load() {
    if (cache) return cache;
    cache = new Promise(function (resolve) {
      var all = [], seen = {};
      function page(n) {
        fetch(FEED + (FEED.indexOf('?') > -1 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var fresh = 0;
            (j.clubs || []).forEach(function (c) { if (c && c.h && !seen[c.h]) { seen[c.h] = 1; all.push(c); fresh++; } });
            // keep going only if this page really was a new page
            if (fresh > 0 && j.page === n && j.page < j.pages && n < 20) page(n + 1); else resolve(clean(all));
          })
          .catch(function () { resolve(clean(all)); });
      }
      page(1);
    });
    return cache;
  }

  /* Partner clubs set up as blocks in the Show up section win over the club entries,
     so the perk shown in Look up always matches the featured club. */
  function partnerOverrides() {
    var map = {};
    document.querySelectorAll('[data-feat-blocks]').forEach(function (el) {
      try { (JSON.parse(el.textContent) || []).forEach(function (b) { if (b && b.h) map[b.h] = b; }); } catch (e) {}
    });
    return map;
  }
  /* Partner programme switch (Theme settings → H32 · Partner programme). While it's off, nobody is
     treated as a partner: no perks, no codes, no partner highlighting, no intro pop-up. */
  function partnersLive() { return window.H32_PARTNERS_LIVE !== false; }
  function clean(list) {
    var t = today(), live = partnersLive(), over = live ? partnerOverrides() : {};
    return list.filter(function (c) {
      if (!c || !c.n) return false;
      if (c.k === 'Event' && c.e && c.e < t) return false; // past events drop off automatically
      return true;
    }).map(function (c) {
      c.a = (c.a || []).filter(Boolean);
      // parkruns are always free: list them and map them, but never treat them as partners or feature them
      c.free = /park\s*run/i.test(c.n || '');
      var o = over[c.h];
      if (o && !c.free) {
        c.p = true;
        if (o.pk) c.pk = o.pk;
        if (o.wm) c.wm = o.wm;
        if (o.wf) c.wf = o.wf;
      }
      if (c.free || !live) { c.p = false; c.pk = null; c.dc = null; }
      c.la = c.la == null || c.la === '' ? null : Number(c.la);
      c.lo = c.lo == null || c.lo === '' ? null : Number(c.lo);
      return c;
    });
  }

  function miles(a, b, c, d) {
    var R = 3958.8, toR = Math.PI / 180;
    var dLa = (c - a) * toR, dLo = (d - b) * toR;
    var x = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a * toR) * Math.cos(c * toR) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }

  function fmtDist(mi, country) {
    if (mi == null) return '';
    if (country === 'UK' || country === 'US' || !country) {
      return (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi';
    }
    return Math.round(mi * 1.609) + ' km';
  }

  function saveLoc(loc) { try { localStorage.setItem(LOC_KEY, JSON.stringify(loc)); } catch (e) {} try { window.dispatchEvent(new CustomEvent('h32:location', { detail: loc })); } catch (e) {} }
  function getLoc() { try { return JSON.parse(localStorage.getItem(LOC_KEY) || 'null'); } catch (e) { return null; } }

  var UK_POSTCODE = /^[A-Z]{1,2}\d[A-Z\d]?\s*(\d[A-Z]{2})?$/i;

  function geocode(q) {
    q = (q || '').trim();
    if (!q) return Promise.reject(new Error('empty'));
    if (UK_POSTCODE.test(q)) {
      var full = /\d[A-Z]{2}$/i.test(q.replace(/\s/g, ''));
      var url = full ? 'https://api.postcodes.io/postcodes/' + encodeURIComponent(q)
                     : 'https://api.postcodes.io/outcodes/' + encodeURIComponent(q.replace(/\s/g, ''));
      return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        if (!j.result) throw new Error('not found');
        return { lat: j.result.latitude, lng: j.result.longitude, label: q.toUpperCase(), cc: 'GB' };
      });
    }
    // Bare 5-digit codes are ambiguous (US ZIP vs German PLZ): lean on the shop's current market.
    var hint = '';
    if (/^\d{5}$/.test(q)) {
      var cur = (window.Shopify && Shopify.country) || '';
      hint = cur === 'DE' ? ', Deutschland' : cur === 'US' ? ', USA' : '';
    }
    var p = 'https://photon.komoot.io/api/?limit=1&lang=en&q=' + encodeURIComponent(q + hint);
    return fetch(p).then(function (r) { return r.json(); }).then(function (j) {
      var f = j.features && j.features[0];
      if (!f) throw new Error('not found');
      var pr = f.properties || {};
      var label = /^\d/.test(q) ? q.toUpperCase() : (pr.name || q) + (pr.state && pr.countrycode === 'US' ? ', ' + pr.state : '');
      return { lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0], label: label, cc: (pr.countrycode || '').toUpperCase() };
    });
  }

  function locateMe() {
    return new Promise(function (resolve, reject) {
      if (!navigator.geolocation) return reject(new Error('unsupported'));
      navigator.geolocation.getCurrentPosition(function (p) {
        resolve({ lat: p.coords.latitude, lng: p.coords.longitude, label: 'you' });
      }, reject, { timeout: 10000, maximumAge: 600000 });
    });
  }

  /* filters: { acts: ['swim','run'], perks: bool, kind: 'Club'|'Event'|'' } — activities are OR, perks is AND */
  function addDays(n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); }
  function weekendRange() {
    var d = new Date(), wd = d.getDay(); // 0 Sun .. 6 Sat
    var toSat = wd === 0 ? -1 : 6 - wd;
    var sat = new Date(d); sat.setDate(d.getDate() + toSat);
    var sun = new Date(sat); sun.setDate(sat.getDate() + 1);
    return [sat.toISOString().slice(0, 10), sun.toISOString().slice(0, 10)];
  }
  /* when: '' | 'weekend' | '7' | '30' | '90'. Events must fall in the window; clubs meet regularly,
     so they always pass except for 'weekend', where they need a SAT/SUN session (or no fixed day). */
  function inWindow(c, when) {
    if (!when) return true;
    if (when === 'weekend') {
      if (c.k === 'Event') { var w = weekendRange(); return !!c.e && c.e >= w[0] && c.e <= w[1]; }
      return !c.d || c.d === 'SAT' || c.d === 'SUN';
    }
    if (c.k !== 'Event') return true;
    return !!c.e && c.e >= today() && c.e <= addDays(Number(when));
  }

  function matches(c, f) {
    if (f.when && !inWindow(c, f.when)) return false;
    if (f.perks && !c.p) return false;
    if (f.kind && c.k !== f.kind) return false;
    if (f.acts && f.acts.length) {
      var have = c.a.map(function (x) { return x.toLowerCase(); });
      var ok = f.acts.some(function (a) { return have.indexOf(a) > -1; });
      if (!ok) return false;
    }
    return true;
  }

  function withDistance(list, loc) {
    return list.map(function (c) {
      c.dist = (loc && c.la != null) ? miles(loc.lat, loc.lng, c.la, c.lo) : null;
      return c;
    });
  }

  /* Days until the next session: events use their date, weekly clubs their next weekday, others go last. */
  var WD = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 };
  function nextIn(c) {
    if (c.k === 'Event' && c.e) return Math.round((new Date(c.e + 'T12:00:00') - new Date(today() + 'T12:00:00')) / 864e5);
    var d = WD[(c.d || '').toUpperCase()];
    if (d == null) return 9999;
    var diff = (d - new Date().getDay() + 7) % 7;
    return diff;
  }
  /* mode: 'loc' (nearest first, needs a location), 'date' (soonest session first), '' (default) */
  function sort(list, loc, mode) {
    if (mode === 'date') {
      return list.slice().sort(function (x, y) {
        var a = nextIn(x), b = nextIn(y);
        if (a !== b) return a - b;
        if (x.dist != null && y.dist != null) return x.dist - y.dist;
        return x.n.localeCompare(y.n);
      });
    }
    return list.slice().sort(function (x, y) {
      if (loc) {
        if (x.dist == null) return 1; if (y.dist == null) return -1;
        return x.dist - y.dist;
      }
      if (x.p !== y.p) return x.p ? -1 : 1;                 // partnered first
      if (x.k !== y.k) return x.k === 'Event' ? -1 : 1;      // then upcoming events
      if (x.k === 'Event') return (x.e || '').localeCompare(y.e || '');
      return x.n.localeCompare(y.n);
    });
  }

  var DAYS = { MON: 'Mon', TUE: 'Tue', WED: 'Wed', THU: 'Thu', FRI: 'Fri', SAT: 'Sat', SUN: 'Sun' };
  /* The "When" cell, same shape for every row: a small label + one readable value.
     WEEKLY  / Sat 08:45     (club with a regular slot)
     EVENT   / Sun 4 Oct     (one-off date; year shown if not this year)
     TIMES VARY / Check club (no fixed slot published) */
  var DAYNAME = { MON: 'Mon', TUE: 'Tue', WED: 'Wed', THU: 'Thu', FRI: 'Fri', SAT: 'Sat', SUN: 'Sun' };
  function when(c) {
    if (c.k === 'Event' && c.e) {
      var d = new Date(c.e + 'T12:00:00');
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };
      if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
      return { label: 'Event', value: d.toLocaleDateString('en-GB', opts).replace(',', ''), muted: false };
    }
    var day = DAYNAME[(c.d || '').toUpperCase()] || '';
    var tm = (c.tm || '').trim();
    if (day && tm) return { label: 'Weekly', value: day + ' ' + tm, muted: false };
    if (day) return { label: 'Weekly', value: day + ', time varies', muted: false };
    if (tm) return { label: 'Regular', value: tm, muted: false };
    return { label: 'Times vary', value: 'Check club', muted: true };
  }
  function whenHtml(c, cls) {
    var w = when(c);
    return '<span class="' + cls + '"><small>' + esc(w.label) + '</small><b' + (w.muted ? ' class="is-muted"' : '') + '>' + esc(w.value) + '</b></span>';
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  function directions(c) {
    if (c.la == null) return '';
    return 'https://www.google.com/maps/dir/?api=1&destination=' + c.la + ',' + c.lo;
  }


  /* ---------- Inline map (used by the Look up section) ---------- */
  var leafletP = null;
  function loadLeaflet() {
    if (window.L && window.L.markerClusterGroup) return Promise.resolve();
    if (leafletP) return leafletP;
    function css(h) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = h; document.head.appendChild(l); }
    function js(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
    var cdn = 'https://cdnjs.cloudflare.com/ajax/libs/';
    css(cdn + 'leaflet/1.9.4/leaflet.min.css'); css(cdn + 'leaflet.markercluster/1.5.3/MarkerCluster.min.css');
    leafletP = (window.L ? Promise.resolve() : js(cdn + 'leaflet/1.9.4/leaflet.min.js')).then(function () { return js(cdn + 'leaflet.markercluster/1.5.3/leaflet.markercluster.min.js'); });
    return leafletP;
  }

  function cardHtml(c, introUrl) {
    var dist = c.dist != null ? ' · ' + fmtDist(c.dist) : '';
    var w = when(c);
    var where = [c.l, c.t].filter(Boolean).filter(function (v, i, arr) { return arr.indexOf(v) === i; }).join(', ');
    var h = '<div class="h32-cm__cardtop"><span>' + esc(c.a.join(' · ')) + ' · ' + esc(c.k) + dist + '</span><button type="button" class="h32-cm__x" data-close aria-label="Close">×</button></div>' +
      '<div class="h32-cm__cardname">' + esc(c.n) + '</div>' +
      '<div class="h32-cm__cardwhere">' + esc(where) + ' · ' + esc(c.s || w.value) + '</div>';
    if (c.no) h += '<div class="h32-cm__cardnote">' + esc(c.no) + '</div>';
    if (c.p && c.pk) h += '<span class="h32-cm__cardperk">★ Perk · ' + esc(c.pk) + '</span>';
    if (c.p) h += claimBtnHtml(c, 'h32-btn h32-btn--solid h32-claim--card');
    h += '<div class="h32-cm__cardbtns">';
    if (c.w) h += '<a class="h32-btn" href="' + esc(c.w) + '" target="_blank" rel="noopener">' + (c.k === 'Event' ? 'View event →' : 'View club →') + '</a>';
    if (c.la != null) h += '<a class="h32-btn" href="' + directions(c) + '" target="_blank" rel="noopener">Directions</a>';
    h += '</div>';
    if (c.gp !== 'exact') h += '<span class="h32-cm__approx">Pin shows the area. Check the club\'s page for the exact meeting point.</span>';
    return h;
  }


  /* ---------- Claim a partnered club: saves it on the cart (for the intro) and applies its 20% code ---------- */
  var CLUB_KEY = 'h32-club';
  function claimed() { try { return localStorage.getItem(CLUB_KEY) || ''; } catch (e) { return ''; } }
  function setClaimed(h) { try { if (h) localStorage.setItem(CLUB_KEY, h); else localStorage.removeItem(CLUB_KEY); } catch (e) {} }
  function unclaim() {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Club': '', 'Club handle': '', 'Club perk': '', 'Introduce me': '', 'Intro name': '', 'Intro email': '', 'Intro phone': '', 'Intro postcode': '', 'Intro agreed': '' }, discount: '' }) })
      .then(function () { setClaimed(''); });
  }
  /* The cart is the source of truth: if it no longer names a club, forget the saved one */
  var cartChecked = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
    var name = cart && cart.attributes && cart.attributes.Club;
    if (!name) setClaimed('');
    return name || '';
  }).catch(function () { return ''; });
  function claimBtnHtml(c, cls) {
    var on = claimed() === c.h;
    return '<span class="h32-claimwrap"><button type="button" class="' + cls + ' h32-claim' + (on ? ' is-on' : '') + '" data-claim="' + esc(c.h) + '">' +
      (on ? '✓ Added · shop gear →' : 'Add club perk + 20% off gear') + '</button>' +
      '<button type="button" class="h32-unclaim" data-unclaim="' + esc(c.h) + '"' + (on ? '' : ' hidden') + '>Remove</button></span>';
  }
  /* ---------- Intro request: name + email + consent, then the code ----------
     1. Sends you a record of the request as a contact-form email.
     2. Saves them as a customer tagged h32-intro + club-<handle> (marketing only if they tick it).
     3. Puts the club, details and consent on the cart, applies the club's code and shows it.
     Nothing goes to the club here. The intro is only made after a PAID order carrying these details,
     and only after screening (see README: "Verified club intros"). */
  var INTRO_KEY = 'h32-intros';
  function intros() { try { return JSON.parse(localStorage.getItem(INTRO_KEY) || '{}'); } catch (e) { return {}; } }
  function saveIntro(h, rec) { try { var all = intros(); all[h] = rec; localStorage.setItem(INTRO_KEY, JSON.stringify(all)); } catch (e) {} }
  function postForm(fields) {
    var body = new URLSearchParams();
    body.append('utf8', '✓');
    Object.keys(fields).forEach(function (k) { body.append(k, fields[k]); });
    return fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin' }).then(function (r) {
      if (/challenge/.test(r.url)) throw new Error('challenge');
      return r;
    });
  }
  function applyClub(c, rec) {
    var attrs = { 'Club': c.n, 'Club handle': c.h, 'Club perk': c.pk || '', 'Introduce me': 'Yes', 'Intro name': ((rec.first || '') + ' ' + (rec.last || '')).trim(), 'Intro email': rec.email || '', 'Intro phone': rec.phone || '', 'Intro postcode': rec.postcode || '', 'Intro agreed': rec.at || '' };
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function () { return c.dc ? fetch('/discount/' + encodeURIComponent(c.dc), { credentials: 'same-origin' }) : null; })
      .then(function () {
        setClaimed(c.h);
        try { window.dispatchEvent(new CustomEvent('h32:claimed', { detail: c })); } catch (e) {}
        return c;
      });
  }
  var modal = null;
  function buildModal() {
    var m = document.createElement('div');
    m.className = 'h32 h32-intro';
    m.hidden = true;
    m.innerHTML =
      '<div class="h32-intro__scrim" data-x></div>' +
      '<div class="h32-intro__box" role="dialog" aria-modal="true" aria-labelledby="h32-intro-h">' +
        '<button type="button" class="h32-intro__close" data-x aria-label="Close">×</button>' +
        '<div data-step="form">' +
          '<span class="h32-eyebrow h32-intro__club" data-club></span>' +
          '<h2 class="h32-intro__h" id="h32-intro-h">Get introduced. Get your perk.</h2>' +
          '<p class="h32-intro__lead">Order your gear and we’ll introduce you to <b data-club-name></b>. You’ll also unlock…</p>' +
          '<ul class="h32-intro__wins">' +
            '<li><b data-perk></b><span>Your club perk from <span data-club-name></span></span></li>' +
            '<li><b>20% off your gear</b><span>Applied to your basket straight away.</span></li>' +
            '<li><b>Introductions made</b><span>Once your order’s placed, they’ll know your name and be looking out for you</span></li>' +
          '</ul>' +
          '<form class="h32-intro__form" novalidate>' +
            '<div class="h32-intro__pair"><label><span>First name</span><input name="first" type="text" autocomplete="given-name" required></label>' +
            '<label><span>Last name</span><input name="last" type="text" autocomplete="family-name" required></label></div>' +
            '<label><span>Email</span><input name="email" type="email" autocomplete="email" required></label>' +
            '<div class="h32-intro__pair"><label><span>Phone <i>(optional)</i></span><input name="phone" type="tel" autocomplete="tel"></label>' +
            '<label><span>Postcode / ZIP</span><input name="postcode" type="text" autocomplete="postal-code" required></label></div>' +
            '<label class="h32-intro__tick"><input name="ok" type="checkbox" required><span>When I order, introduce me to <b data-club-name></b> and share my name, email, phone number and postcode area with them so they can welcome me.</span></label>' +
            '<label class="h32-intro__tick"><input name="news" type="checkbox"><span>Send me Hiemal32 news and offers (optional).</span></label>' +
            '<button type="submit" class="h32-btn h32-btn--solid h32-intro__go" disabled>Introduce me + get my code</button>' +
            '<p class="h32-intro__msg" data-msg aria-live="polite"></p>' +
            '<p class="h32-intro__small">We only pass your details to this club, and only after you’ve placed an order. Your postcode also helps us show you sessions nearby. <a href="/policies/privacy-policy" target="_blank">Privacy policy</a></p>' +
          '</form>' +
        '</div>' +
        '<div data-step="done" hidden>' +
          '<span class="h32-eyebrow h32-intro__club" data-club></span>' +
          '<h2 class="h32-intro__h">You’re all set.</h2>' +
          '<p class="h32-intro__lead">Place your order and we’ll introduce you to <b data-club-name></b>. Your perk, <b data-perk></b>, will be waiting.</p>' +
          '<div class="h32-intro__code"><span class="h32-mono">Your code</span><b data-code></b><button type="button" class="h32-mono" data-copy>Copy</button></div>' +
          '<p class="h32-intro__small">20% off is already applied to your basket.</p>' +
          '<a class="h32-btn h32-btn--solid h32-intro__go" data-shop href="/collections/all">Shop gear with 20% off →</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    var form = m.querySelector('form'), go = form.querySelector('button[type=submit]');
    function check() { go.disabled = !(form.first.value.trim() && form.last.value.trim() && /\S+@\S+\.\S+/.test(form.email.value) && form.postcode.value.trim().length >= 3 && form.ok.checked); }
    form.addEventListener('input', check); form.addEventListener('change', check);
    m.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
    m.querySelector('[data-copy]').addEventListener('click', function (e) {
      var code = m.querySelector('[data-code]').textContent;
      try { navigator.clipboard.writeText(code); e.target.textContent = 'Copied'; } catch (x) {}
    });
    function close() { m.hidden = true; document.documentElement.classList.remove('h32-noscroll'); if (m._reject) { m._reject(new Error('closed')); m._reject = null; } }
    m._close = close; m._check = check;
    return m;
  }
  function showDone(m, c) {
    m.querySelector('[data-step=form]').hidden = true;
    m.querySelector('[data-step=done]').hidden = false;
    m.querySelector('[data-code]').textContent = c.dc || '';
  }
  function claim(c, shopUrl) {
    modal = modal || buildModal();
    var m = modal, form = m.querySelector('form');
    m.querySelectorAll('[data-club]').forEach(function (x) { x.textContent = c.n + ' × Hiemal32'; });
    m.querySelectorAll('[data-club-name]').forEach(function (x) { x.textContent = c.n; });
    m.querySelectorAll('[data-perk]').forEach(function (x) { x.textContent = c.pk || 'A welcome perk'; });
    m.querySelector('[data-shop]').href = shopUrl || '/collections/all';
    m.querySelector('[data-copy]').textContent = 'Copy';
    m.querySelector('[data-msg]').textContent = '';
    var done = intros()[c.h];
    m.querySelector('[data-step=form]').hidden = !!done;
    m.querySelector('[data-step=done]').hidden = !done;
    if (!done) { form.reset(); m._check(); }
    m.hidden = false;
    document.documentElement.classList.add('h32-noscroll');
    if (done) {
      // already introduced in this browser: re-apply the code and show it
      showDone(m, c);
      return applyClub(c, done);
    }
    setTimeout(function () { form.first.focus(); }, 30);
    return new Promise(function (resolve, reject) {
      m._reject = reject;
      form.onsubmit = function (e) {
        e.preventDefault();
        m._check();
        var go = form.querySelector('button[type=submit]');
        if (go.disabled) return;
        go.disabled = true; go.textContent = 'One moment…';
        var rec = { first: form.first.value.trim(), last: form.last.value.trim(), email: form.email.value.trim(), phone: form.phone.value.trim(), postcode: form.postcode.value.trim().toUpperCase(), news: form.news.checked, at: new Date().toISOString() };
        var consent = 'When I order, introduce me to ' + c.n + ' and share my name, email, phone number and postcode area with them so they can welcome me.';
        var note = ['Club intro request (sent to the club only after a paid order)', 'Club: ' + c.n, 'Perk: ' + (c.pk || ''), 'Code: ' + (c.dc || ''),
          'Name: ' + rec.first + ' ' + rec.last, 'Email: ' + rec.email, 'Phone: ' + (rec.phone || '(not given)'), 'Postcode / ZIP: ' + rec.postcode, 'Agreed: ' + consent, 'Agreed at: ' + rec.at,
          'Hiemal32 news: ' + (rec.news ? 'Yes' : 'No')].join('\n');
        var record = postForm({ form_type: 'contact', 'contact[name]': rec.first + ' ' + rec.last, 'contact[email]': rec.email, 'contact[Club]': c.n, 'contact[body]': note });
        var customer = postForm({ form_type: 'customer', 'contact[email]': rec.email, 'contact[first_name]': rec.first, 'contact[last_name]': rec.last,
          'contact[tags]': 'h32-intro,club-' + c.h + (rec.news ? ',newsletter' : ''), 'contact[accepts_marketing]': rec.news ? 'true' : 'false' }).catch(function () {});
        record.then(function () { return customer; }).then(function () {
          saveIntro(c.h, rec);
          // no location set yet? use their postcode so nearby clubs and sessions come first
          if (!getLoc() && rec.postcode) geocode(rec.postcode).then(saveLoc).catch(function () {});
          return applyClub(c, rec);
        }).then(function () {
          go.textContent = 'Introduce me + get my code';
          m._reject = null;
          showDone(m, c);
          resolve(c);
        }).catch(function (err) {
          go.disabled = false; go.textContent = 'Introduce me + get my code';
          m.querySelector('[data-msg]').textContent = err && err.message === 'challenge'
            ? 'Please try again in a moment. Our spam check needs a second.'
            : 'Something went wrong. Please try again.';
        });
      };
    });
  }
  /* One delegated handler for every "Add club perk" button on the page */
  function wireClaims(root, getClub, shopUrl) {
    function paint() {
      var cur = claimed();
      root.querySelectorAll('[data-claim]').forEach(function (x) {
        var on = x.dataset.claim === cur;
        x.classList.toggle('is-on', on); x.disabled = false;
        x.textContent = on ? '✓ Added · shop gear →' : 'Add club perk + 20% off gear';
      });
      root.querySelectorAll('[data-unclaim]').forEach(function (x) { x.hidden = x.dataset.unclaim !== cur; });
    }
    cartChecked.then(paint);
    window.addEventListener('h32:claimed', paint);
    root.addEventListener('click', function (e) {
      var u = e.target.closest('[data-unclaim]');
      if (u) { e.preventDefault(); e.stopPropagation(); u.textContent = 'Removing…'; unclaim().then(function () { u.textContent = 'Remove'; paint(); }); return; }
      var b = e.target.closest('[data-claim]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var c = getClub(b.dataset.claim);
      if (!c) return;
      if (b.classList.contains('is-on')) { location.href = shopUrl || '/collections/all'; return; }
      claim(c, shopUrl).then(paint).catch(paint);
    }, true);
  }

  /* "You are here" marker + a locate-me button for any Leaflet map */
  function meIcon(loc) {
    var name = !loc || loc.label === 'you' ? 'You' : loc.label;
    return L.divIcon({ className: 'h32-me-wrap', html: '<div class="h32-me"><i></i></div><span class="h32-me__label">' + esc(name) + '</span>', iconSize: [22, 22], iconAnchor: [11, 11] });
  }
  function addLocate(map, onLoc) {
    var C = L.Control.extend({ options: { position: 'topright' }, onAdd: function () {
      var b = L.DomUtil.create('button', 'h32-locate');
      b.type = 'button'; b.title = 'Show my location'; b.setAttribute('aria-label', 'Show my location');
      b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>';
      L.DomEvent.disableClickPropagation(b);
      L.DomEvent.on(b, 'click', function () {
        b.classList.add('is-busy');
        locateMe().then(function (loc) { b.classList.remove('is-busy'); saveLoc(loc); if (onLoc) onLoc(loc); })
          .catch(function () { b.classList.remove('is-busy'); b.title = 'Location blocked by your browser'; b.classList.add('is-off'); });
      });
      return b;
    } });
    map.addControl(new C());
  }

  /* Cluster bubbles: lime when any partner club is inside, dark otherwise */
  function clusterIcon(cl) {
    var kids = cl.getAllChildMarkers(), n = cl.getChildCount(), partner = false;
    for (var i = 0; i < kids.length; i++) if (kids[i].options.partner) { partner = true; break; }
    var size = n < 10 ? 40 : n < 100 ? 44 : 50;
    return L.divIcon({ html: '<div><span>' + n + '</span></div>', className: 'marker-cluster' + (partner ? ' h32-cluster--p' : ''), iconSize: L.point(size, size) });
  }
  function clusterGroup() { return L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 44, iconCreateFunction: clusterIcon }); }

  function MapView(wrap, opts) {
    opts = opts || {};
    var self = this, map, cluster, markers = {}, meMarker, list = [], loc = null;
    var mapEl = wrap.querySelector('[data-mapel]'), card = wrap.querySelector('[data-card]');
    self.ready = loadLeaflet().then(function () {
      map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: false, worldCopyJump: true }).setView([51.5, -0.12], 5);
      L.control.zoom({ position: 'topright' }).addTo(map);
      addLocate(map, function (l) { if (opts.onLocate) opts.onLocate(l); });
      L.tileLayer(opts.tiles || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: opts.attrib || '&copy; OpenStreetMap contributors' }).addTo(map);
      map.on('focus', function () { map.scrollWheelZoom.enable(); });
      map.on('blur', function () { map.scrollWheelZoom.disable(); });
      cluster = clusterGroup();
      map.addLayer(cluster);
      if (window.ResizeObserver) new ResizeObserver(function () { map.invalidateSize(); }).observe(mapEl);
      touchGuard();
    });
    /* Phones: one finger scrolls the page past the map. Two fingers move and zoom the map,
       and a single tap on the map unlocks one-finger panning until the map scrolls out of view. */
    function touchGuard() {
      if (!(window.matchMedia && matchMedia('(pointer: coarse)').matches)) return;
      var el = map.getContainer(), unlocked = false, sx = 0, sy = 0, moved = false, hintT;
      map.dragging.disable();
      var hint = document.createElement('div');
      hint.className = 'h32-maphint'; hint.hidden = true;
      hint.textContent = 'Use two fingers to move the map, or tap it once';
      wrap.appendChild(hint);
      function showHint() { hint.hidden = false; clearTimeout(hintT); hintT = setTimeout(function () { hint.hidden = true; }, 1600); }
      function lock() { unlocked = false; map.dragging.disable(); wrap.classList.remove('is-live'); }
      function unlock() { unlocked = true; map.dragging.enable(); wrap.classList.add('is-live'); hint.hidden = true; }
      el.addEventListener('touchstart', function (e) {
        if (unlocked) return;
        if (e.touches.length > 1) { map.dragging.enable(); return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (unlocked || e.touches.length > 1) return;
        if (Math.abs(e.touches[0].clientX - sx) + Math.abs(e.touches[0].clientY - sy) > 12) { moved = true; showHint(); }
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (unlocked) return;
        if (e.touches.length === 0) { map.dragging.disable(); if (!moved) unlock(); }
      }, { passive: true });
      if (window.IntersectionObserver) new IntersectionObserver(function (en) { if (!en[0].isIntersecting) lock(); }, { threshold: 0.2 }).observe(wrap);
    }
    function pin(c) {
      var cls = 'h32-pin' + (c.p ? ' h32-pin--p' : '') + (c.k === 'Event' ? ' h32-pin--e' : '');
      var s = c.p ? 20 : 16;
      return L.divIcon({ className: '', html: '<div class="' + cls + '"></div>', iconSize: [s, s], iconAnchor: [s / 2, s / 2] });
    }
    self.fit = function () {
      if (!map) return;
      map.invalidateSize();
      var pts = list.filter(function (c) { return c.la != null; });
      if (loc) {
        // centre on the visitor, with their nearest few clubs in view
        var near = pts.filter(function (c) { return c.dist != null && c.dist <= 40; })
          .sort(function (a, b) { return a.dist - b.dist; }).slice(0, 3);
        if (!near.length) { map.setView([loc.lat, loc.lng], 9); return; }
        var ll = near.map(function (c) { return [c.la, c.lo]; });
        ll.push([loc.lat, loc.lng]);
        map.fitBounds(L.latLngBounds(ll).pad(0.3), { maxZoom: 12 });
        return;
      }
      // no location yet: show this store's country, not the whole world
      var mk = { GB: 'UK', US: 'US', DE: 'DE' }[(window.Shopify && Shopify.country) || 'GB'] || 'UK';
      var local = pts.filter(function (c) { return c.c === mk; });
      if (local.length) pts = local;
      var all = pts.map(function (c) { return [c.la, c.lo]; });
      if (all.length) map.fitBounds(L.latLngBounds(all).pad(0.05), { maxZoom: 10 });
    };
    self.set = function (clubs, location) {
      list = clubs; loc = location;
      return self.ready.then(function () {
        cluster.clearLayers(); markers = {};
        list.forEach(function (c) {
          if (c.la == null) return;
          var m = L.marker([c.la, c.lo], { icon: pin(c), title: c.n, keyboard: true, partner: !!c.p });
          if (c.p) m.on('click', function () { self.select(c.h, false); });
          else m.bindTooltip(esc(c.n) + (c.t ? ' · ' + esc(c.t) : ''), { direction: 'top', offset: [0, -8], className: 'h32-cm__tip' });
          markers[c.h] = m; cluster.addLayer(m);
        });
        if (meMarker) { map.removeLayer(meMarker); meMarker = null; }
        if (loc) meMarker = L.marker([loc.lat, loc.lng], { icon: meIcon(loc), interactive: false, zIndexOffset: 1000 }).addTo(map);
        self.fit();
      });
    };
    self.select = function (h, pan) {
      var c = list.filter(function (x) { return x.h === h; })[0];
      if (!c || !card) return;
      card.innerHTML = cardHtml(c, opts.introUrl); card.hidden = false;
      card.querySelector('[data-close]').addEventListener('click', function () { card.hidden = true; if (opts.onClose) opts.onClose(); });
      if (opts.onSelect) opts.onSelect(h);
      self.ready.then(function () {
        if (pan && markers[h]) cluster.zoomToShowLayer(markers[h], function () { map.setView([c.la, c.lo], Math.max(map.getZoom(), 11), { animate: false }); map.panBy([0, Math.round(card.offsetHeight / 2)], { animate: true }); });
        else if (markers[h]) map.panTo(map.containerPointToLatLng(map.latLngToContainerPoint([c.la, c.lo]).add([0, Math.round(card.offsetHeight / 2)])));
      });
    };
    self.hideCard = function () { if (card) card.hidden = true; };
  }

  /* Switch the store's market (UK / US / Germany) to the one nearest a location. Needs the
     localization form + markets JSON that the Look up section prints. */
  var EUROPE = 'AT BE BG CH CY CZ DE DK EE ES FI FR GR HR HU IS IT LI LT LU LV MT NL NO PL PT RO SE SI SK'.split(' ');
  function switchMarket(loc, returnTo) {
    var el = document.querySelector('[data-h32-markets]'), form = document.getElementById('h32-market-form');
    if (!el || !form || !loc || !loc.cc) return false;
    var m; try { m = JSON.parse(el.textContent); } catch (e) { return false; }
    var avail = (m.available || []).map(function (c) { return String(c).toUpperCase(); });
    var cc = String(loc.cc).toUpperCase(); if (cc === 'UK') cc = 'GB';
    var target = avail.indexOf(cc) > -1 ? cc
      : (cc === 'IE' && avail.indexOf('GB') > -1) ? 'GB'
      : (EUROPE.indexOf(cc) > -1 && avail.indexOf('DE') > -1) ? 'DE'
      : (['CA', 'MX', 'PR'].indexOf(cc) > -1 && avail.indexOf('US') > -1) ? 'US' : '';
    if (!target || target === String(m.current || '').toUpperCase()) return false;
    form.querySelector('[name="country_code"]').value = target;
    form.querySelector('[name="return_to"]').value = returnTo || location.pathname;
    form.submit();
    return true;
  }

  window.H32Clubs = { load: load, geocode: geocode, locateMe: locateMe, saveLoc: saveLoc, getLoc: getLoc,
    matches: matches, withDistance: withDistance, sort: sort, when: when, whenHtml: whenHtml, MapView: MapView, switchMarket: switchMarket, claim: claim, unclaim: unclaim, claimed: claimed, claimBtnHtml: claimBtnHtml, wireClaims: wireClaims, meIcon: meIcon, addLocate: addLocate, cardHtml: cardHtml, loadLeaflet: loadLeaflet, clusterGroup: clusterGroup, esc: esc, fmtDist: fmtDist, directions: directions, DAYS: DAYS, partnersLive: partnersLive };
})();
